import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const ComputerFill = memo((props: IconProps) => {
    const { color = "#fff", ...rest } = props
    return (
        <svg width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...rest}>
            <path
                fill={color}
                d="M.09 7.755a6.628 6.628 0 0 1 0-2.173c.734.017 1.394-.335 1.651-.954.257-.62.039-1.336-.493-1.842a6.628 6.628 0 0 1 1.537-1.538c.507.532 1.223.75 1.843.493.62-.257.971-.917.953-1.651.72-.12 1.455-.12 2.175 0-.018.734.334 1.394.953 1.651.62.257 1.336.039 1.842-.493a6.627 6.627 0 0 1 1.538 1.537c-.532.507-.75 1.223-.493 1.843.256.62.917.971 1.651.953.12.72.12 1.455 0 2.175-.735-.018-1.395.334-1.651.953-.257.62-.039 1.336.493 1.842a6.628 6.628 0 0 1-1.537 1.538c-.507-.532-1.223-.75-1.843-.493-.62.256-.971.917-.953 1.651-.72.12-1.455.12-2.175 0 .018-.735-.334-1.395-.953-1.651-.62-.257-1.336-.039-1.842.493a6.627 6.627 0 0 1-1.538-1.537c.532-.507.75-1.223.493-1.843-.257-.62-.917-.971-1.651-.953Zm6.578.913a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            />
        </svg>
    )
})

export default ComputerFill
